import React, { useState, useEffect } from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import AccettateAnalisiKPISet from "../accettateAnalisi/AccettateAnalisi.KPISet";

const AccettateTimeline = ({ dataProviderName, filters: defaultFilters, $key }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState(false);
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const shaped = { items: [...(filterModel.items || []), { field: "status", operator: "equals", value: "accepted" }] };
        setLocalFilterModel(shaped);
        setLocalDrawable(true);
    }, [filterModel]);

    const showKPI = true;
    const showAccettateTimeline = true;

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Accettate')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <AccettateAnalisiKPISet dataProviderName={dataProviderName} filters={filterModel} />
                </Box>
            }

            {showAccettateTimeline && localDrawable &&
                <Box className="report-itemgroup report-itemgroup-timeline" sx={{ marginTop: '10px', marginBottom: '30px' }}>
                    <Box className="report-item">
                        <Bar
                            title={t("Accepted per mese")}
                            dataProviderName="statisticsviews/acceptedbymonth/timelined/views_opportunities_proposal/registered_at/month/null/_related_area_name"
                            filters={localFilterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            showTooltip={true}
                        />
                        <Bar
                            title={t("Accepted per settimana")}
                            dataProviderName="statisticsviews/acceptedbyweek/timelined/views_opportunities_proposal/registered_at/week"
                            filters={localFilterModel}
                            handleFilterChange={createTimelineBarFilterHandler('registered_at', addFilter)}
                            height={200}
                        />
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default AccettateTimeline;
